module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol-observable/index.js
// module id = 1088
// module chunks = 58